import { call, takeEvery } from 'redux-saga/effects';
import { USER_LOGOUT } from '../constants/login.constants';
import api from '../../socket';

function* logoutUserRequest({ action }) {
    yield call(api.logout, action);
}

export default function* logoutSaga() {
    yield takeEvery(USER_LOGOUT, logoutUserRequest);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/logout.saga.js